export default {
    // Header Section
    "discover_your": "ನಿಮ್ಮ",
    "career_path": "ವೃತ್ತಿ ಮಾರ್ಗವನ್ನು ಅನ್ವೇಷಿಸಿ",
    "professional_destiny_analysis": "ವೃತ್ತಿಪರ ಭಾಗ್ಯ ವಿಶ್ಲೇಷಣೆ",
    "career_report_description": "ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯದ ಆಧಾರದ ಮೇಲೆ ಸಮಗ್ರ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆಯೊಂದಿಗೆ ನಿಮ್ಮ ವೃತ್ತಿಪರ ಸಾಮರ್ಥ್ಯವನ್ನು ಬಿಚ್ಚಿಡಿ. ಆದರ್ಶ ವೃತ್ತಿ ಮಾರ್ಗಗಳು, ವ್ಯಾಪಾರ ನಿರೀಕ್ಷೆಗಳು, ವೃತ್ತಿ ಬದಲಾವಣೆಯ ಸಮಯ ಮತ್ತು ವೃತ್ತಿಪರ ಯಶಸ್ಸಿನ ಕಾರ್ಯತಂತ್ರಗಳ ಒಳನೋಟಗಳನ್ನು ಪಡೆಯಿರಿ.",

    // Service Information
    "enter_details_for_career_analysis": "ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆಗಾಗಿ ನಿಮ್ಮ ವಿವರಗಳನ್ನು ನಮೂದಿಸಿ",
    "complete_career_analysis": "ಸಂಪೂರ್ಣ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆ",
    "service_price": "ಸೇವೆಯ ಬೆಲೆ",
    "comprehensive_career_analysis_note": "ನಿಮ್ಮ ವೃತ್ತಿಪರ ಸಾಮರ್ಥ್ಯ ಮತ್ತು ವೃತ್ತಿ ರೋಡ್‌ಮ್ಯಾಪ್‌ನ ಆಳವಾದ ವಿಶ್ಲೇಷಣೆ",

    // Form Fields
    "full_name": "ಪೂರ್ಣ ಹೆಸರು",
    "enter_full_name": "ನಿಮ್ಮ ಪೂರ್ಣ ಹೆಸರನ್ನು ನಮೂದಿಸಿ",
    "name_career_influence": "ನಿಮ್ಮ ಹೆಸರು ನಿಮ್ಮ ವೃತ್ತಿಪರ ಖ್ಯಾತಿ ಮತ್ತು ಯಶಸ್ಸಿನ ಮಾದರಿಗಳನ್ನು ಪ್ರಭಾವಿಸುತ್ತದೆ",
    "email_address": "ಇಮೇಲ್ ವಿಳಾಸ",
    "enter_email_address": "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
    "phone_number": "ದೂರವಾಣಿ ಸಂಖ್ಯೆ",
    "enter_phone_number": "ನಿಮ್ಮ ದೂರವಾಣಿ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
    "gender": "ಲಿಂಗ",
    "male": "ಪುರುಷ",
    "female": "ಮಹಿಳೆ",
    "other": "ಇತರೆ",
    "date_of_birth": "ಜನ್ಮ ದಿನಾಂಕ",
    "birth_date_career_path": "ನಿಮ್ಮ ವೃತ್ತಿ-ಆಧಾರಿತ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ನಿರ್ಧರಿಸಲು ಅತ್ಯಗತ್ಯ",
    "time_of_birth": "ಜನ್ಮ ಸಮಯ",
    "exact_time_critical_for_career": "ನಿಖರವಾದ ವೃತ್ತಿ ಗೃಹ ಲೆಕ್ಕಾಚಾರಗಳಿಗೆ ನಿಖರವಾದ ಸಮಯ ಅಗತ್ಯ",
    "place_of_birth": "ಜನ್ಮ ಸ್ಥಳ",
    "place_of_birth_placeholder": "ನಗರ, ರಾಜ್ಯ, ದೇಶ",
    "location_essential_for_career": "ಸ್ಥಳವು ವೃತ್ತಿಯನ್ನು ಪ್ರಭಾವಿಸುವ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ಪರಿಣಾಮ ಬೀರುತ್ತದೆ",
    "preferred_language": "ಆದ್ಯತೆಯ ಭಾಷೆ",
    "english": "ಇಂಗ್ಲಿಷ್",
    "hindi": "ಹಿಂದಿ",
    "telugu": "ತೆಲುಗು",
    "kannada": "ಕನ್ನಡ",
    "language_note": "ಆಯ್ಕೆಮಾಡಿದ ಭಾಷೆಯಲ್ಲಿ ನಿಮ್ಮ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗುವುದು",

    // Core Career Features
    "ideal_career_paths": "ಆದರ್ಶ ವೃತ್ತಿ ಮಾರ್ಗಗಳು",
    "professional_strengths_analysis": "ವೃತ್ತಿಪರ ಶಕ್ತಿಗಳ ವಿಶ್ಲೇಷಣೆ",
    "business_prospects_guidance": "ವ್ಯಾಪಾರ ನಿರೀಕ್ಷೆಗಳ ಮಾರ್ಗದರ್ಶನ",
    "career_timing_predictions": "ವೃತ್ತಿ ಸಮಯ ಭವಿಷ್ಯವಾಣಿಗಳು",
    "skill_development_recommendations": "ಕೌಶಲ್ಯ ಅಭಿವೃದ್ಧಿ ಶಿಫಾರಸುಗಳು",
    "pdf_download": "ಸಮಗ್ರ PDF ವರದಿ",

    "what_you_get": "ನಿಮ್ಮ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆಯಲ್ಲಿ ಏನು ಸೇರಿದೆ",
    "detailed_career_roadmap": "ವಿಸ್ತೃತ ವೃತ್ತಿ ರೋಡ್‌ಮ್ಯಾಪ್",
    "professional_strengths_weaknesses": "ವೃತ್ತಿಪರ ಶಕ್ತಿಗಳು ಮತ್ತು ದುರ್ಬಲತೆಗಳು",
    "business_entrepreneurship_guidance": "ವ್ಯಾಪಾರ ಮತ್ತು ಉದ್ಯಮಶೀಲತೆ ಮಾರ್ಗದರ್ಶನ",
    "career_transition_timing": "ವೃತ್ತಿ ಬದಲಾವಣೆಯ ಸಮಯ",

    // Actions & Buttons
    "pay_and_generate_analysis": "ನನ್ನ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆ ಪಡೆಯಿರಿ",
    "processing_payment": "ಪಾವತಿ ಸಂಸ್ಕರಿಸುತ್ತಿದೆ",
    "processing_request": "ವಿಶ್ಲೇಷಣೆ ರಚಿಸುತ್ತಿದೆ",

    // Payment & Success Messages
    "thank_you": "ಧನ್ಯವಾದಗಳು",
    "payment_successful": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಿದೆ!",
    "career_analysis_processing": "ನಿಮ್ಮ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆಯನ್ನು ನಮ್ಮ ಪರಿಣಿತ ವೈದಿಕ ಜ್ಯೋತಿಷಿಗಳು ತಯಾರಿಸುತ್ತಿದ್ದಾರೆ. ನಿಮ್ಮ ವೃತ್ತಿಪರ ಸಾಮರ್ಥ್ಯ ಮತ್ತು ಆದರ್ಶ ವೃತ್ತಿ ಮಾರ್ಗಗಳ ಬಗ್ಗೆ ವಿಸ್ತೃತ ಒಳನೋಟಗಳನ್ನು ನೀವು ಸ್ವೀಕರಿಸುತ್ತೀರಿ.",
    "order_id": "ಆರ್ಡರ್ ID",
    "payment_id": "ಪಾವತಿ ID",
    "amount_paid": "ಪಾವತಿಸಿದ ಮೊತ್ತ",

    // Delivery Information
    "delivery_information": "ವಿತರಣಾ ಮಾಹಿತಿ",
    "delivery_time": "ವಿಶ್ಲೇಷಣೆ ವಿತರಣೆ",
    "within_12_hours_delivery_note": "ನಿಮ್ಮ ವಿಸ್ತೃತ ವೃತ್ತಿ ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧವಾಗುತ್ತದೆ",
    "whatsapp_notification": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು",
    "whatsapp_delivery_note": "WhatsApp ನಲ್ಲಿ ತಕ್ಷಣ ಅಧಿಸೂಚನೆಗಳನ್ನು ಸ್ವೀಕರಿಸಿ",
    "email_delivery": "ಇಮೇಲ್ ವಿತರಣೆ",
    "email_delivery_note": "ಸಂಪೂರ್ಣ ವಿಶ್ಲೇಷಣೆಯನ್ನು ವಿತರಿಸಲಾಗಿದೆ",

    // What You'll Receive
    "what_youll_receive": "ನಿಮ್ಮ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆ ಪ್ಯಾಕೇಜ್",
    "detailed_career_report": "ಸಮಗ್ರ ವೃತ್ತಿ ವರದಿ (PDF)",
    "suitable_career_options": "ಸೂಕ್ತ ವೃತ್ತಿ ಆಯ್ಕೆಗಳು ಮತ್ತು ಕ್ಷೇತ್ರಗಳು",
    "professional_development_plan": "ವೃತ್ತಿಪರ ಅಭಿವೃದ್ಧಿ ಯೋಜನೆ",
    "success_timing_analysis": "ಯಶಸ್ಸಿನ ಸಮಯ ವಿಶ್ಲೇಷಣೆ",
    "entrepreneurship_assessment": "ಉದ್ಯಮಶೀಲತೆಯ ಮೌಲ್ಯಮಾಪನ",

    // Visual Content
    "sample_career_analysis": "ಮಾದರಿ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆ",
    "ideal_career_field": "ಆದರ್ಶ ವೃತ್ತಿ ಕ್ಷೇತ್ರ",
    "sample_career_description": "ತಂತ್ರಜ್ಞಾನ ಮತ್ತು ನವೀನತೆ - ಬಲವಾದ ವಿಶ್ಲೇಷಣಾತ್ಮಕ ಮತ್ತು ನಾಯಕತ್ವ ಸಾಮರ್ಥ್ಯಗಳು",
    "sample_career_preview": "ಕ್ಷೇತ್ರ ಶಿಫಾರಸುಗಳೊಂದಿಗೆ ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆಯ ಪೂರ್ವವೀಕ್ಷಣೆ",
    "career_fields": "ವೃತ್ತಿ ಕ್ಷೇತ್ರಗಳು",

    // Career Field Types
    "technology": "ತಂತ್ರಜ್ಞಾನ",
    "healthcare": "ಆರೋಗ್ಯ ಸೇವೆ",
    "finance": "ಹಣಕಾಸು",
    "creative_arts": "ಸೃಜನಾತ್ಮಕ ಕಲೆಗಳು",
    "education": "ಶಿಕ್ಷಣ",
    "business": "ವ್ಯಾಪಾರ",

    // Status & Processing
    "your_career_analysis_status": "ನಿಮ್ಮ ವೃತ್ತಿ ವಿಶ್ಲೇಷಣೆ ಸ್ಥಿತಿ",
    "processing_your_analysis": "ನಿಮ್ಮ ವೃತ್ತಿ ಸಾಮರ್ಥ್ಯವನ್ನು ವಿಶ್ಲೇಷಿಸುತ್ತಿದೆ",
    "analysis_processing_message": "ನಮ್ಮ ವೈದಿಕ ಜ್ಯೋತಿಷ್ಯ ಪರಿಣಿತರು ನಿಮ್ಮ ಆದರ್ಶ ವೃತ್ತಿ ಮಾರ್ಗ ಮತ್ತು ವೃತ್ತಿಪರ ಸಮಯವನ್ನು ನಿರ್ಧರಿಸಲು ನಿಮ್ಮ ಗ್ರಹ ಸ್ಥಾನಗಳನ್ನು ಅಧ್ಯಯನ ಮಾಡುತ್ತಿದ್ದಾರೆ.",
    "request_id": "ವಿಶ್ಲೇಷಣೆ ID",
    "status": "ಸ್ಥಿತಿ",
    "processing": "ಪ್ರಗತಿಯಲ್ಲಿದೆ",
    "pending": "ಸರದಿಯಲ್ಲಿದೆ",
    "email_notification_sent": "ದೃಢೀಕರಣ ಇಮೇಲ್ ಕಳುಹಿಸಲಾಗಿದೆ",
    "whatsapp_update_coming": "WhatsApp ಅಪ್‌ಡೇಟ್‌ಗಳು ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ",
    "delivery_within_12_hours": "ವರದಿ ೧೨ ಗಂಟೆಗಳೊಳಗೆ ಸಿದ್ಧ",

    // Support & Contact
    "contact_support": "ವೃತ್ತಿ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ",
    "need_help": "ಮಾರ್ಗದರ್ಶನ ಬೇಕೇ?",
    "contact_us_at": "ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ",

    // Error Messages
    "please_fill_all_required_fields": "ದಯವಿಟ್ಟು ಎಲ್ಲಾ ಅಗತ್ಯ ವಿವರಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ",
    "payment_failed": "ಪಾವತಿ ಯಶಸ್ವಿಯಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "processing_failed": "ವಿಶ್ಲೇಷಣೆ ಸಂಸ್ಕರಣೆ ವಿಫಲವಾಗಿದೆ. ನಮ್ಮ ಬೆಂಬಲ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ.",

    // Career-Specific Elements
    "tenth_house": "೧೦ನೇ ಗೃಹ (ವೃತ್ತಿ ಗೃಹ)",
    "ascendant_lord": "ಲಗ್ನ ಅಧಿಪತಿ",
    "career_planets": "ವೃತ್ತಿ-ಪ್ರಭಾವಿ ಗ್ರಹಗಳು",
    "professional_dasha": "ವೃತ್ತಿಪರ ದಶಾ ಅವಧಿಗಳು",
    "career_yogas": "ವೃತ್ತಿ ಯೋಗಗಳು",
    "success_indicators": "ಯಶಸ್ಸಿನ ಸೂಚಕಗಳು",

    // Career Analysis Sections
    "natural_talents": "ನೈಸರ್ಗಿಕ ಪ್ರತಿಭೆಗಳು ಮತ್ತು ಸಾಮರ್ಥ್ಯಗಳು",
    "professional_personality": "ವೃತ್ತಿಪರ ವ್ಯಕ್ತಿತ್ವ",
    "leadership_qualities": "ನಾಯಕತ್ವ ಗುಣಗಳು",
    "work_preferences": "ಕೆಲಸದ ಪರಿಸರ ಆದ್ಯತೆಗಳು",
    "career_motivations": "ವೃತ್ತಿ ಪ್ರೇರಣೆಗಳು",
    "professional_challenges": "ವೃತ್ತಿಪರ ಸವಾಲುಗಳು",

    // Suitable Career Paths
    "recommended_careers": "ಶಿಫಾರಸು ಮಾಡಿದ ವೃತ್ತಿ ಮಾರ್ಗಗಳು",
    "alternative_careers": "ಪರ್ಯಾಯ ವೃತ್ತಿ ಆಯ್ಕೆಗಳು",
    "avoid_careers": "ತಪ್ಪಿಸಬೇಕಾದ ವೃತ್ತಿಗಳು",
    "freelancing_potential": "ಫ್ರೀಲ್ಯಾನ್ಸಿಂಗ್ ಸಾಮರ್ಥ್ಯ",
    "government_vs_private": "ಸರ್ಕಾರಿ ವಿರುದ್ಧ ಖಾಸಗಿ ವಲಯ",
    "international_opportunities": "ಅಂತಾರಾಷ್ಟ್ರೀಯ ವೃತ್ತಿ ಅವಕಾಶಗಳು",

    // Business & Entrepreneurship
    "business_acumen": "ವ್ಯಾಪಾರ ಬುದ್ಧಿವಂತಿಕೆ",
    "entrepreneurial_skills": "ಉದ್ಯಮಶೀಲತೆ ಕೌಶಲ್ಯಗಳು",
    "partnership_compatibility": "ವ್ಯಾಪಾರ ಪಾಲುದಾರಿಕೆ ಹೊಂದಾಣಿಕೆ",
    "investment_timing": "ಹೂಡಿಕೆ ಸಮಯ",
    "business_sectors": "ಸೂಕ್ತ ವ್ಯಾಪಾರ ವಲಯಗಳು",
    "startup_potential": "ಸ್ಟಾರ್ಟಪ್ ಯಶಸ್ಸಿನ ಸಾಮರ್ಥ್ಯ",

    // Professional Development
    "skill_enhancement": "ಕೌಶಲ್ಯ ವರ್ಧನೆ ಕ್ಷೇತ್ರಗಳು",
    "educational_recommendations": "ಶೈಕ್ಷಣಿಕ ಶಿಫಾರಸುಗಳು",
    "certification_suggestions": "ಪ್ರಮಾಣಪತ್ರ ಸಲಹೆಗಳು",
    "mentorship_guidance": "ಮಾರ್ಗದರ್ಶಕತ್ವ ಮಾರ್ಗದರ್ಶನ",
    "networking_strategies": "ನೆಟ್‌ವರ್ಕಿಂಗ್ ಕಾರ್ಯತಂತ್ರಗಳು",
    "personal_branding": "ವೈಯಕ್ತಿಕ ಬ್ರಾಂಡಿಂಗ್ ಸಲಹೆಗಳು",

    // Career Timing
    "career_growth_periods": "ವೃತ್ತಿ ಬೆಳವಣಿಗೆ ಅವಧಿಗಳು",
    "job_change_timing": "ಅತ್ಯುತ್ತಮ ಉದ್ಯೋಗ ಬದಲಾವಣೆ ಸಮಯ",
    "promotion_periods": "ಪ್ರೋನ್ನತಿ ಅನುಕೂಲ ಅವಧಿಗಳು",
    "salary_negotiation_timing": "ಸಂಬಳ ಮಾತುಕತೆ ಸಮಯ",
    "business_launch_timing": "ವ್ಯಾಪಾರ ಆರಂಭ ಸಮಯ",
    "retirement_planning": "ನಿವೃತ್ತಿ ಯೋಜನೆ ಮಾರ್ಗದರ್ಶನ",

    // Success Strategies
    "professional_networking": "ವೃತ್ತಿಪರ ನೆಟ್‌ವರ್ಕಿಂಗ್",
    "workplace_relationships": "ಕೆಲಸದ ಸ್ಥಳದ ಸಂಬಂಧಗಳು",
    "conflict_resolution": "ಸಂಘರ್ಷ ಪರಿಹಾರ ಕೌಶಲ್ಯಗಳು",
    "stress_management": "ವೃತ್ತಿಪರ ಒತ್ತಡ ನಿರ್ವಹಣೆ",
    "work_life_balance": "ಕೆಲಸ-ಜೀವನ ಸಮತೋಲನ",
    "career_setback_recovery": "ವೃತ್ತಿ ಹಿನ್ನಡೆ ಚೇತರಿಕೆ",

    // Financial Aspects
    "earning_potential": "ಗಳಿಕೆ ಸಾಮರ್ಥ್ಯ",
    "wealth_accumulation": "ಸಂಪತ್ತು ಸಂಗ್ರಹ ಮಾದರಿಗಳು",
    "financial_planning": "ಹಣಕಾಸು ಯೋಜನೆ ಸಲಹೆ",
    "investment_guidance": "ಹೂಡಿಕೆ ಮಾರ್ಗದರ್ಶನ",
    "passive_income_opportunities": "ನಿಷ್ಕ್ರಿಯ ಆದಾಯ ಅವಕಾಶಗಳು",
    "financial_security_timing": "ಹಣಕಾಸಿನ ಭದ್ರತೆ ಸಮಯಸೀಮೆ",

    // Industry-Specific Guidance
    "it_software": "IT ಮತ್ತು ಸಾಫ್ಟ್‌ವೇರ್",
    "banking_finance": "ಬ್ಯಾಂಕಿಂಗ್ ಮತ್ತು ಹಣಕಾಸು",
    "healthcare_medical": "ಆರೋಗ್ಯ ಸೇವೆ ಮತ್ತು ವೈದ್ಯಕೀಯ",
    "education_training": "ಶಿಕ್ಷಣ ಮತ್ತು ತರಬೇತಿ",
    "media_entertainment": "ಮಾಧ್ಯಮ ಮತ್ತು ಮನರಂಜನೆ",
    "manufacturing_engineering": "ಉತ್ಪಾದನೆ ಮತ್ತು ಎಂಜಿನಿಯರಿಂಗ್",
    "sales_marketing": "ಮಾರಾಟ ಮತ್ತು ಮಾರ್ಕೆಟಿಂಗ್",
    "consulting_services": "ಸಲಹಾ ಮತ್ತು ಸೇವೆಗಳು",

    // Professional Relationships
    "boss_relationships": "ಮೇಲಧಿಕಾರಿಗಳೊಂದಿಗಿನ ಸಂಬಂಧಗಳು",
    "colleague_dynamics": "ಸಹೋದ್ಯೋಗಿ ಡೈನಾಮಿಕ್ಸ್",
    "team_leadership": "ತಂಡದ ನಾಯಕತ್ವ ಶೈಲಿ",
    "client_relationships": "ಗ್ರಾಹಕ ಸಂಬಂಧ ನಿರ್ವಹಣೆ",
    "vendor_partnerships": "ಮಾರಾಟಗಾರ ಮತ್ತು ಪಾಲುದಾರಿಕೆ ನಿರ್ವಹಣೆ",

    // Career Remedies
    "career_remedies": "ವೃತ್ತಿ ವರ್ಧನೆ ಪರಿಹಾರಗಳು",
    "professional_gemstones": "ವೃತ್ತಿಪರ ರತ್ನಗಳು",
    "career_mantras": "ವೃತ್ತಿ ಯಶಸ್ಸಿನ ಮಂತ್ರಗಳು",
    "workplace_vastu": "ಕೆಲಸದ ಸ್ಥಳದ ವಾಸ್ತು ಸಲಹೆಗಳು",
    "professional_colors": "ವೃತ್ತಿಪರ ಅದೃಷ್ಟದ ಬಣ್ಣಗಳು",
    "career_fasting": "ವೃತ್ತಿ-ಪ್ರಯೋಜನಕಾರಿ ಉಪವಾಸ"
};
